<template>
  <div class="row g-2">
    <div v-for="step in stepsNumber" :key="step" class="col">
      <div class="progress" style="height: 5px!important;" role="progressbar" aria-label="Example high" aria-valuemin="0" aria-valuemax="100">
        <div
            class="progress-bar"
            :class="{'w-100': step <= currentStep, 'w-0': step > currentStep}"
            :style="{ backgroundColor: step <= currentStep ? activeColor +'!important' : '', height: '5px' }">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { defineProps } from "vue"
defineProps({
  stepsNumber: { type: Number, default: 6 },
  currentStep: { type: Number, default: 1 },
  activeColor: { type: String, default: '#0072CE' },
})

</script>

<style scoped>

</style>
